export var ActionKeys;
(function (ActionKeys) {
    ActionKeys["LOGIN"] = "USER/LOGIN";
    ActionKeys["LOGOUT"] = "USER/LOGOUT";
    ActionKeys["FETCH_USER"] = "USER/FETCH_USER";
    ActionKeys["LOGIN_PENDING"] = "USER/LOGIN_PENDING";
    ActionKeys["LOGOUT_PENDING"] = "USER/LOGOUT_PENDING";
    ActionKeys["FETCH_USER_PENDING"] = "USER/FETCH_USER_PENDING";
    ActionKeys["SET_USER"] = "USER/SET_USER";
    ActionKeys["UNSET_USER"] = "USER/UNSET_USER";
    ActionKeys["SET_ERROR"] = "USER/SET_ERROR";
})(ActionKeys || (ActionKeys = {}));
export var userStatus;
(function (userStatus) {
    userStatus["LOGGEDIN"] = "LOGGEDIN";
    userStatus["PENDING"] = "PENDING";
    userStatus["LOGERROR"] = "LOGERROR";
    userStatus["LOGGEDOUT"] = "LOGGEDOUT";
})(userStatus || (userStatus = {}));
//# sourceMappingURL=actionTypes.js.map